// extracted by mini-css-extract-plugin
export var bodySections = "_8z-8";
export var gray = "_8z-7";
export var green = "_8z-4";
export var iconContainer = "_8z-9";
export var iconWidgetContainer = "_8z-1";
export var phoneIcon = "_8z-2";
export var red = "_8z-5";
export var statusDot = "_8z-3";
export var widgetContainer = "_8z-0";
export var yellow = "_8z-6";